import Button from '@/components/shared/components/stylish-disclosure/button';
import Panel from '@/components/shared/components/stylish-disclosure/panel';

export { Button as StylishAccordionButton, Panel as StylishAccordionPanel };
